var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-lgs-view" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "c-lgs-view_container" }, [
      _c("div", { staticClass: "c-lgs-view_container__inner" }, [
        _c("div", { staticClass: "c-view-content-col" }, [
          _c("div", { staticClass: "c-view-content-col__inner" }, [
            _c("div", {
              staticClass: "c-lgs-content",
              domProps: {
                innerHTML: _vm._s(_vm.LetsGetStarted.LetsGetStartedViewContent),
              },
            }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "u-calc-button", on: { click: _vm.start } },
              [_c("p", [_vm._v("Let's get started")]), _vm._v(" "), _c("span")]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-lgs-view_animation-col c-view-animation-col" },
          [
            _c(
              "div",
              { staticClass: "c-lgs-view_animation-wrapper" },
              [
                _c("lottie-vue-player", {
                  attrs: {
                    src: _vm.animationsURL + `logo_money_animation.json`,
                    "player-controls": false,
                    loop: true,
                    autoplay: true,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-speech-bubble" }, [
      _c("div", { staticClass: "c-speech-bubble__inner" }, [
        _c("h1", { staticClass: "c-speech-bubble__heading" }, [
          _vm._v("\n        Calculate your\n        "),
          _c("span", { staticClass: "c-speech-bubble__heading--yellow" }, [
            _vm._v("power savings"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }